/* Rimozione player video */
document.querySelectorAll('deferred-media video').forEach((video) => {
    video.removeAttribute('controls');
});

function circle_icons_animations () {

    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();

    //desktop
    mm.add("(min-width: 750px)", () => {

        gsap.timeline({
            scrollTrigger: {
                trigger: '.step_home',
                start: 'top center+=120px',
            }
        })
            .from('.text_arrow_step', { opacity: 0, y: '-=8', duration: .4 })
            .from('.anim_text_1', { opacity: 0, x: -8, duration: .7, ease: 'power3.out'}, '<.2')
            .from('.anim_card', { opacity: 0, scale: .8, duration: .7, ease: 'power3.out'})
            .from('.anim_circ_1', { opacity: 0, scale: .2, transformOrigin: 'center', duration: .7, ease: 'power3.out'}, '<.3')
            .from('.anim_boll_1, .anim_boll_2, .anim_boll_3', { scale: .2, opacity: 0, duration: .4, ease: 'power2.in'}, '<')
            .add(() => { document.querySelector('.blue_halo > animate').beginElement() }, '<')
            .add(() => { document.querySelector('.anim_boll_1 > animateMotion').beginElement() }, '<')
            .add(() => { document.querySelector('.anim_boll_2 > animateMotion').beginElement() }, '>.4')
            .add(() => { document.querySelector('.anim_boll_3 > animateMotion').beginElement() }, '>.4')

        return () => {};
    });

    //mobile
    mm.add("(max-width: 749px)", () => {
        gsap.from('.anim_mob_group_1', {
            scrollTrigger: {
                trigger: '.anim_mob_group_1',
                start: 'top 80%',
            },
            opacity: 0,
            y: 20,
            duration: .8,
            ease: 'power3.inOut'
        })

        gsap.from('.anim_mob_group_2', {
            scrollTrigger: {
                trigger: '.anim_mob_group_2',
                start: 'top 80%',
            },
            opacity: 0,
            y: 20,
            duration: .8,
            ease: 'power3.inOut'
        })

        gsap.timeline({
            scrollTrigger: {
                trigger: '.anim_mob_step_1',
                start: 'top 75%',
            }
        })
            .from('.anim_mob_card_1', { opacity: 0, scale: .8, duration: .7, ease: 'power3.out'})
            .from('.anim_mob_boll_1, .anim_mob_boll_2, .anim_mob_boll_3', { scale: .2, opacity: 0, duration: .7, ease: 'power2.in'})
            .add(() => { document.querySelector('.blue_halo_mob animate').beginElement() }, '<')
            .add(() => { document.querySelector('.anim_mob_boll_1 > animateMotion').beginElement() }, '<')
            .add(() => { document.querySelector('.anim_mob_boll_2 > animateMotion').beginElement() }, '>.4')
            .add(() => { document.querySelector('.anim_mob_boll_3 > animateMotion').beginElement() }, '>.4')

        return () => {};
    })


    // boll cliccabili (solo se NON siamo nella pagina index)
    if (!document.querySelector('main[data-template="index"]')) {
        document.querySelectorAll('.anim_boll_1').forEach((el) => {
            el.onclick = () => {
                location.href = '/account/login';
            }
        })
        document.querySelectorAll('.anim_boll_2').forEach((el) => {
            el.onclick = () => {
                location.href = '/pages/circoli';
            }
        })
        document.querySelectorAll('.anim_boll_3').forEach((el) => {
            el.onclick = () => {
                location.href = '/products/card';
            }
        })
    }
}

function home_animations() {
    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();

    //desktop
    mm.add("(min-width: 750px)", () => {
        gsap.timeline({
            scrollTrigger: {
                trigger: '.three_image_card_rotate',
                start: 'top center',
            }
        })
            .from('.anim_card_3', { filter: 'blur(1px)', scale: 1.15, transformOrigin:'center', duration: .8, ease: 'power3.in'})
            .from('.anim_card_1', { rotate: 0, x: 200, duration: .7, ease: 'power3.out'})
            .from('.anim_card_3', { rotate: 0, x: -200, y: 50, duration: .7, ease: 'power3.out'}, '<')
        

        // "porta un amico"
        gsap.from('.float_element_top_left', {
            scrollTrigger: {
                trigger: '.float_element_top_left',
                start: 'top 70%',
            },
            opacity: 0,
            y: 20,
            duration: .8,
            ease: 'power3.inOut'
        })

        // "lo sapevi che"
        gsap.from('.float_element_top_right', {
            scrollTrigger: {
                trigger: '.float_element_top_right',
                start: 'top 70%',
            },
            opacity: 0,
            y: 20,
            duration: .8,
            ease: 'power3.inOut'
        })


        gsap.from('.float_element_center', {
            scrollTrigger: {
                trigger: '.float_element_center',
                start: 'top 70%',
            },
            opacity: 0,
            y: 20,
            duration: .8,
            ease: 'power3.inOut'
        })

        gsap.from('.bottom_element', {
            scrollTrigger: {
                trigger: '.bottom_element',
                start: 'top 80%',
            },
            opacity: 0,
            y: 20,
            duration: .8,
            ease: 'power3.inOut'
        })

        return () => {};
    });

    //mobile
    mm.add("(max-width: 749px)", () => {
        //foto cards
        gsap.timeline({
            scrollTrigger: {
                trigger: '.three_image_card_rotate',
                start: 'top 70%',
            }
        })
            .from('.anim_card_3', { opacity: 0, scale: .8, rotate: -70, y: 50, duration: .7, ease: 'power3.out'})
            .from('.anim_card_1', { opacity: 0, scale: .8, rotate: 20, y: 50, duration: .7, ease: 'power3.out'}, '<.5')

        return () => {};
    })
}

function text_reveal_animation() {
    // Animated Text Reveal JavaScript
    if (typeof gsap !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);

        // Contatore per determinare ordine di apparizione
        let textCounter = 0;

        // Funzione per processare il testo e creare le parole animate
        function processAnimatedText(element) {
            // Se già processato, skip
            if (element.classList.contains('processed')) {
                return;
            }

            // Incrementa contatore
            textCounter++;

            // Ottieni i parametri dai data attributes o usa i default
            const finalColor = element.dataset.color || getComputedStyle(element).color || '#333333';
            const grayColor = element.dataset.grayColor || '#cccccc';

            // Velocità ottimizzate: outline veloce, colore ultra lento
            const wordDelay = parseFloat(element.dataset.delay) || 0.03; // Outline veloce
            const colorDelay = parseFloat(element.dataset.colorDelay) || (wordDelay * 16); // Colore 16x più lento del grigio

            // Funzione ricorsiva per processare tutti i nodi di testo
            function wrapTextNodes(node) {
                if (node.nodeType === 3) { // Text node
                    const text = node.textContent;
                    if (text.trim()) {
                        const words = text.split(/(\s+)/); // Mantieni anche gli spazi
                        const fragment = document.createDocumentFragment();

                        words.forEach(word => {
                            if (word.trim()) {
                                // È una parola
                                const span = document.createElement('span');
                                span.className = 'animated-word';
                                span.textContent = word;
                                span.style.color = 'transparent';
                                // span.style.webkitTextStroke = '1px #000';
                                // span.style.textStroke = '1px #000';
                                span.style.transform = 'translateY(15px) rotateX(90deg) scale(0.8)';
                                span.style.transformOrigin = 'center bottom';
                                fragment.appendChild(span);
                            } else {
                                // È uno spazio, mantienilo come testo
                                fragment.appendChild(document.createTextNode(word));
                            }
                        });

                        node.parentNode.replaceChild(fragment, node);
                    }
                } else if (node.nodeType === 1) { // Element node
                    // Processa tutti i figli
                    const children = Array.from(node.childNodes);
                    children.forEach(child => wrapTextNodes(child));
                }
            }

            // Processa tutti i nodi di testo nell'elemento
            wrapTextNodes(element);

            // Segna come processato
            element.classList.add('processed');

            // Crea l'animazione
            const animatedWords = element.querySelectorAll('.animated-word');

            // Crea la timeline principale
            const tl = gsap.timeline({
                paused: true,
                onComplete: () => {
                    element.classList.add('animation-completed');
                }
            });

            // Animazione di apparizione delle parole con effetti originali
            animatedWords.forEach((word, index) => {
                // Effetto di entrata più dinamico
                tl.to(word, {
                    opacity: 1,
                    y: 0,
                    rotationX: 0,
                    scale: 1,
                    duration: 0.4,
                    ease: "back.out(1.2)"
                }, index * wordDelay)
                // Coloring con un leggero pulse
                .to(word, {
                    color: finalColor,
                    duration: 0.3,
                    ease: "power2.inOut"
                }, index * wordDelay + colorDelay)
                // Micro pulse per dare vita
                .to(word, {
                    scale: 1.02,
                    duration: 0.1,
                    ease: "power2.inOut"
                }, index * wordDelay + colorDelay + 0.1)
                .to(word, {
                    scale: 1,
                    duration: 0.2,
                    ease: "power2.out"
                }, index * wordDelay + colorDelay + 0.2);
            });

            // ScrollTrigger per attivare l'animazione quando entra nel viewport
            ScrollTrigger.create({
                trigger: element,
                start: "top 80%",
                end: "bottom 20%",
                once: true,
                onEnter: () => {
                    if (!element.classList.contains('animation-completed')) {
                        tl.play();
                    }
                }
            });
        }

        // Trova tutti gli elementi con classe animated-text
        function initAnimatedTexts() {
            const animatedElements = document.querySelectorAll('.animated-text');
            animatedElements.forEach(processAnimatedText);
        }

        // Inizializza al caricamento
        initAnimatedTexts();

        // Observer per elementi aggiunti dinamicamente (Gutenberg)
        const observer = new MutationObserver(function(mutations) {
            let shouldReinit = false;
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        if (node.classList.contains('animated-text') ||
                            node.querySelector('.animated-text')) {
                            shouldReinit = true;
                        }
                    }
                });
            });

            if (shouldReinit) {
                setTimeout(initAnimatedTexts, 100);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Funzione per aggiornare le animazioni su resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 250);
        });

        // API pubblica
        window.AnimatedTextReveal = {
            trigger: function(selector) {
                const containers = document.querySelectorAll(selector);
                containers.forEach(container => {
                    if (!container.classList.contains('animation-completed')) {
                        const event = new CustomEvent('triggerAnimation');
                        container.dispatchEvent(event);
                    }
                });
            },

            reset: function(selector) {
                const containers = document.querySelectorAll(selector);
                containers.forEach(container => {
                    container.classList.remove('animation-completed', 'processed');
                    // Reset counter per riassegnare velocità
                    textCounter = 0;
                    processAnimatedText(container);
                });
            },

            init: initAnimatedTexts
        };

    } else {
        console.warn('GSAP non caricato - Animated Text Reveal disabilitato');
    }
}

// function title_reveal_animation () {
//     gsap.registerPlugin(ScrollTrigger, SplitText);

//     document.querySelectorAll('.title-one-line-anim').forEach((title) => {
//         const h1h2h3 = title.querySelector('h1,h2,h3');
//         gsap.timeline({
//             scrollTrigger: {
//                 trigger: title,
//                 start: 'top center',
//             },
//         })
//             .set(title, { opacity: 1 }, '>.4')
//             .set(h1h2h3, { display: 'block' })
//             .fromTo(
//                 h1h2h3,
//                 { y: '110%' },
//                 { y: 0, duration: .7, ease: 'power2.inOut' }
//             );

//     });

//     document.querySelectorAll('.title-reveal-anim h1, .title-reveal-anim h2, .title-reveal-anim h3, .title-reveal-anim p').forEach((title) => {
//         const splittedTitle = new SplitText(title, { type: 'lines', mask: 'lines', linesClass: 'title-anim-line' });
//         const titleAnimLines = title.querySelectorAll('.title-anim-line');

//         gsap.timeline({
//             scrollTrigger: {
//                 trigger: title,
//                 start: 'top center',
//             },
//         })
//             .set(title.closest('.title-reveal-anim'), { opacity: 1 }, '>.4')
//             .fromTo(
//                 titleAnimLines,
//                 { y: '110%' },
//                 { y: 0, duration: .7, ease: 'power2.out', stagger: .1 }
//             );

//     });
// }

let ctx;

let formRo = null;

function product_page_pinned_banner_anim(targetScroll = null) {

    if (ctx) ctx.revert();
    if (formRo) { formRo.disconnect(); formRo = null; }

    requestAnimationFrame(() => {

        ctx = gsap.context(() => {
            const pba = document.querySelector('.pinned-banner-anim');
            if (!pba) return;

            const q = (sel) => pba.querySelector(sel);

            // LEFT
            const text_left_1 = q('.pba-left-1');
            const text_left_2 = q('.pba-left-2');
            const text_left_3 = q('.pba-left-3');

            // CENTER
            const text_center_wrapper = q('.price_rotate');
            const text_center_1 = q('.pba-center-1');
            const text_center_2 = q('.pba-center-2');
            const text_center_3 = q('.pba-center-3');

            // RIGHT
            const text_right_1 = q('.pba-right-1');
            const text_right_2 = q('.pba-right-2');
            const text_right_3 = q('.pba-right-3');

            // Safety: qui includi anche right_3
            const required = [
                text_left_1, text_left_2, text_left_3,
                text_center_wrapper, text_center_1, text_center_2, text_center_3,
                text_right_1, text_right_2, text_right_3
            ];
            if (required.some((el) => !el)) return;

            // Stati iniziali (filtra sempre per sicurezza)
            gsap.set([text_left_2, text_left_3, text_right_2, text_right_3].filter(Boolean), { y: 48 });
            gsap.set([text_center_2, text_center_3].filter(Boolean), { y: 250 });
            gsap.set([text_left_1, text_right_1, text_center_1].filter(Boolean), { y: 0 });

            text_center_1.style.margin = '0';


            window.tlpba = gsap.timeline({
                defaults: { ease: "none", duration: 0.25 },
                scrollTrigger: {
                    trigger: pba.closest('.shopify-section.section-wrapper'),
                    start: "center center",
                    end: "+=2000px",
                    scrub: true,
                    pin: true,
                }
            })
                .to('.pinned-banner-anim .price_rotate', { duration: 0.2, rotate: 13 }, '+=0.2')
                .to(text_left_1, { y: -48 }, '<')
                .to(text_left_2, { y: 0 }, '<')
                .to(text_right_1, { y: -48 }, '<')
                .to(text_right_2, { y: 0 }, '<')
                .to('.pinned-banner-anim .price_rotate', { width: 330 }, '<')
                .to(text_center_1, { y: -250 }, '<')
                .to(text_center_2, { y: 0 }, '<')
                .to('.pinned-banner-anim .price_rotate', { rotate: -13 }, '+=0.2')
                .to(text_center_2, { y: -250 }, '<')
                .to(text_center_3, { y: 0 }, '<')
                .to(text_left_2, { y: -48 }, '<')
                .to(text_left_3, { y: 0 }, '<')
                .to(text_right_1, { y: -48 }, '<')
                .to(text_right_2, { y: 0 }, '<')
                .to(text_right_2, { y: -48 }, '<')
                .to(text_right_3, { y: 0 }, '<')
                .to('.pinned-banner-anim .price_rotate', { scale: 1.5 }, '+=.4');

            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        });

        /* Calcola se il form viene compilato per non rompere animazione in caso si apre */
        const formAbove = document.querySelector('#form_card');
        if (formAbove) {
            let baselineHeight = formAbove.offsetHeight;
            let baselineScroll = null;
            let pendingReinit = null;

            formRo = new ResizeObserver(() => {
                const newHeight = formAbove.offsetHeight;
                if (newHeight === baselineHeight) return;

                if (baselineScroll === null) {
                    baselineScroll = window.pageYOffset;
                }

                clearTimeout(pendingReinit);
                pendingReinit = setTimeout(() => {
                    const totalDelta = newHeight - baselineHeight;
                    baselineHeight = newHeight;
                    baselineScroll = null;

                    product_page_pinned_banner_anim();
                }, 200);
            });

            formRo.observe(formAbove);
        }

        requestAnimationFrame(() => {
            ScrollTrigger.refresh();
        });

    });
}


function parallax_animations() {
    try {
        if(window.innerWidth < 768) return;

        document.querySelector('.top_element').setAttribute('data-depth', 0.15);
        document.querySelector('.float_element_center img').setAttribute('data-depth', 0.05);
        document.querySelector('.bottom_element').setAttribute('data-depth', 0.3);

        var scene = document.querySelector('.section_image_centered_rotate .section-content-wrapper');
        if(!scene) return;

        var parallaxInstance = new Parallax(scene, {
            selector: '[data-depth]',
            scalarX: 6,
            scalarY: 6,
        });
        parallaxInstance.friction(0.2, 0.2);

    } catch (error) {
        console.error('Error in parallax_animations', error)
    }
}

function banner_porta_amico_anim() {
    gsap.timeline({
        scrollTrigger: {
            trigger: '.bring-friend-1',
            start: 'top center',
            //markers: true
        }
    })
        .from('.bring-friend-1', { opacity: 0, x: -20, ease: 'power2.out', duration: .4 })
        .from('.bring-friend-1 ~ a img', { opacity: 0, scale: .9, ease: 'elastic', duration: 1.2 })
}

function pagina_circoli_animations() {
    const header = document.querySelector('.pag-cir-header');
    const background_image = document.querySelector('.pag-cir-header img');

    gsap.to(background_image, {
        yPercent: 20,
        ease: "none",
        scrollTrigger: {
            trigger: header,
            start: "top-=100px top",
            end: "bottom top",
            scrub: true,
        }
    });
}

function init () {
    gsap.registerPlugin(ScrollTrigger);

    //title_reveal_animation();

    //pagina prodotto CARD
    if(document.querySelector('.pinned-banner-anim')) {
        product_page_pinned_banner_anim()
    }

    //text reveal animation
    text_reveal_animation();

    //animazione ingresso cerchi (in home e pagina golfpop)
    if(document.querySelector('main[data-template="index"]') || document.querySelector('main[data-template="page.golfpop"]')) {
        circle_icons_animations();
    }

    //animazioni home
    if(document.querySelector('main[data-template="index"]')) {
        home_animations();
        parallax_animations();
    }



    //pagina prodotto CARD
    if(document.querySelector('.bring-friend-1'))
        setTimeout(banner_porta_amico_anim, 140)

    if(document.querySelector('main[data-template="page.circoli"]'))
        pagina_circoli_animations();

    /*pagina GOLFPOP*/
    // if(document.querySelector('main[data-template="page.golfpop"]'))
}

document.addEventListener('DOMContentLoaded', init);

document.addEventListener('DOMContentLoaded', () => {
  const currentPath = window.location.pathname.replace(/\/$/, '');

  document.querySelectorAll('.featured-blog-posts-card__link').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    const linkPath = new URL(href, window.location.origin).pathname.replace(/\/$/, '');

    if (linkPath === currentPath) {
      const item = link.closest('.resource-list__item');
      if (item) item.style.display = 'none'; // oppure item.remove();
    }
  });

  const menuPolicy = document.querySelector('.menu_policy .details-content');
  if (menuPolicy) {
    const menuItems = menuPolicy.querySelectorAll('.menu__item');
    if (menuItems.length >= 3) {
      menuItems[2].classList.add('lb-cs-settings-link');
    }
  }
});
